import React from "react";
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import moment from "moment";
import theme from "../../styles/theme";
import numberHelpers from '../../helpers/number';

Font.register({
  family: "Manrope",
  fonts: [
    {
      src: "/assets/fonts/Manrope-Regular.ttf",
      fontStyle: "normal",
      fontWeight: 400,
      format: "truetype",
    },
    {
      src: "/assets/fonts/Manrope-SemiBold.ttf",
      fontStyle: "normal",
      fontWeight: 600,
      format: "truetype",
    },
  ]
});

const Logo = "/assets/images/walletlong.png";

const ExtractPDF = ({ pdfData, translate }) => {
  const formatCurrency = function(value) {
    return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  };

  const handleDescription = function(transaction) {
    var description = transaction.description;

    if (transaction && transaction.details) {
      var d = transaction.details;
      if (d.item && d.event && d.order && d.lots) {
        description = d.item + " | Evento " + d.event + " | Pedido " + d.order + " | Lote(s) " + d.lots;
      } else if (d.customDescription) {
        description = d.customDescription;
      }
    } else if (transaction && transaction.comment) {
      if (typeof transaction.comment === 'string') {
        description = transaction.comment;
      } else if (transaction.comment.customDescription) {
        description = transaction.comment.customDescription;
      }
    }

    return description;
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <View>
            <Text style={styles.title}>Extrato da conta - sbXPay</Text>
            <View style={styles.subtitle}>
              <Text style={styles.subtitleDescription}>Período:</Text>
              <Text style={styles.subtitleYear}>
                {" " + moment(pdfData.startDate).format('DD/MM/YYYY') + " até " + moment(pdfData.endDate).format('DD/MM/YYYY')}
              </Text>
            </View>
          </View>
          <Image src={Logo} style={styles.logo} />
        </View>

        <View style={styles.content}>
          <View style={styles.divider} />

          <View style={styles.infoContainer}>
            <Text style={styles.infoTitle}>{translate("recipient.client")}:</Text>
            <Text style={styles.infoValue}>{pdfData.name}</Text>
          </View>

          <View style={styles.infoContainer}>
            <Text style={styles.infoTitle}>{translate("recipient.document")}:</Text>
            <Text style={styles.infoValue}>{numberHelpers.documentMask(pdfData.document)}</Text>
          </View>

          {pdfData.agency && pdfData.account && (
            <View style={styles.infoRow}>
              <View style={styles.infoContainer}>
                <Text style={styles.infoTitle}>{translate("recipient.agency")}:</Text>
                <Text style={styles.infoValue}>{pdfData.agency}</Text>
              </View>
              <View style={styles.infoContainer}>
                <Text style={styles.infoTitle}>{translate("recipient.account")}:</Text>
                <Text style={styles.infoValue}>{pdfData.account}</Text>
              </View>
            </View>
          )}
        </View>

        <View style={styles.content}>
          <View style={styles.divider} />
          {pdfData.extractList.length === 0 ? (
            <Text style={styles.disclaimer}>Não foram encontradas transações no período selecionado</Text>
          ) : (
            <View>
              <Text style={styles.transaction}>Transações</Text>
              <View style={styles.tableHeader}>
                <Text style={{ width: '8%' }}>Tipo</Text>
                <Text style={{ width: '10%' }}>Data</Text>
                <Text style={{ width: '30%' }}>Descrição</Text>
                <Text style={{ width: '12%' }}>Itens (R$)</Text>
                <Text style={{ width: '20%' }}>Valor</Text>
                <Text style={{ width: '10%' }}>Nome</Text>
                <Text style={{ width: '10%' }}>Documento</Text>
              </View>
            </View>
          )}

          {pdfData.extractList.map(function(transaction, index) {
            var hasGroupData = transaction.details && Array.isArray(transaction.details.groupData);

            return (
              <View key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <View style={[styles.tableValue, index % 2 === 0 && { backgroundColor: '#F9F1FF' }]}> 
                  <Text style={{ width: '8%', fontSize: 9 }}>MOV</Text>
                  <Text style={{ width: '10%', fontSize: 9 }}>{moment(transaction.creditDate).format("DD/MM/YYYY")}</Text>
                  <Text style={{ width: '30%', fontSize: 8 }}>{handleDescription(transaction)}</Text>
                  <Text style={{ width: '12%', fontSize: 9 }}></Text>
                  <Text style={{ width: '20%', fontSize: 9 }}>
                    {transaction.type === 'D' ? "- " + formatCurrency(transaction.amount) : formatCurrency(transaction.amount)}
                  </Text>
                  <Text style={{ width: '10%', fontSize: 7 }}>{(transaction.counterpart && transaction.counterpart.name) || ''}</Text>
                  <Text style={{ width: '10%', fontSize: 7 }}>{(transaction.counterpart && transaction.counterpart.taxIdentifier && transaction.counterpart.taxIdentifier.taxId) || ''}</Text>
                </View>

                {hasGroupData && transaction.details.groupData.map(function(group, groupIndex) {
                  return (
                    <View key={groupIndex} style={[styles.commentGroupRow, index % 2 === 0 && { backgroundColor: '#F9F1FF' }]}> 
                      <Text style={{ width: '8%', fontSize: 9, textAlign: 'center' }}>ITEM</Text>
                      <Text style={{ width: '10%', fontSize: 9 }}></Text>
                      <Text style={{ width: '30%', fontSize: 8, textAlign: 'center' }}>{"Lote " + group.lot + " | " + group.desc}</Text>
                      <Text style={{ width: '12%', fontSize: 9, textAlign: 'center' }}>{formatCurrency(group.amount)}</Text>
                      <Text style={{ width: '20%', fontSize: 9 }}></Text>
                      <Text style={{ width: '10%', fontSize: 9 }}></Text>
                      <Text style={{ width: '10%', fontSize: 9 }}></Text>
                    </View>
                  );
                })}
              </View>
            );
          })}
        </View>

        <View style={styles.footer}>
          <View style={styles.divider} />
          <View style={styles.ombudsman}>
            <Text style={styles.ombudsmanText}>Ouvidoria</Text>
            <Text style={styles.ombudsmanSubText}>Já falou conosco e não conseguiu resolver o que precisava? Fale com nossa ouvidoria através do 0800 800 0044 Atendemos em dias úteis das 09h às 17h.</Text>
          </View>
          <View style={styles.divider} />
          <Text style={styles.text}>2024 Superbid © • Rua Henrique Monteiro, nº 125, 2º andar - Pinheiros - São Paulo - SP Atendimento de segunda à sexta das 9:00 às 18:00, exceto feriados : (11) 4950 9400</Text>
        </View>
      </Page>
    </Document>
  );
};


const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffff",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    borderTopWidth: 3,
    borderTopColor: theme.colors.brand.primary,
    paddingTop: 28,
    paddingHorizontal: 40
  },
  logo: {
    width: "118px",
    height: "36px",
  },
  title: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 20,
    color: theme.colors.text.medium,
  },
  subtitle: {
    fontFamily: "Manrope",
    fontWeight: 400,
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 15
  },
  subtitleDescription: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 14,
    color: theme.colors.text.medium,
  },
  subtitleYear: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 14,
    color: theme.colors.functional.primary[700],
  },
  content: {
    paddingHorizontal: 12
  },
  contentTitle: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 16,
    color: theme.colors.functional.primary[900]
  },
  divider: {
    width: "100%",
    backgroundColor: theme.colors.text.lightest,
    height: "1px",
    marginBottom: 15
  },
  infoContainer: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    marginTop: 8
  },
  infoTitle: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 12,
    color: theme.colors.text.regular
  },
  infoValue: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 12,
    color: theme.colors.text.medium,
    marginLeft: 4
  },
  infoRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 30
  },
  footer: {
    flex: 1,
    justifyContent: "flex-end",
    paddingHorizontal: 40,
    marginBottom: 16
  },
  text: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 12,
    color: theme.colors.text.medium,
    textAlign: "center",
    marginTop: 8
  },
  transaction: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 18,
    color: theme.colors.text.medium,
    marginBottom: 30
  },
  disclaimer: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 14,
    color: theme.colors.text.medium,
    marginBottom: 30
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: theme.colors.brand.primary,
    padding: 2,
    color: "#FFF",
    textAlign: 'center',
    width: '100%',
    fontSize: 12
  },
  tableBlock: {
    flexDirection: 'row',
    width: '100%'
  },
  tableValueBlock: {
    width: '15%',
  },
  tableValueDescription: {
    width: '40%'
  },
  
  tableTextOne: {
    width: '10%'
  },
  tableTextTwo: {
    width: '30%'
  },
  tableValue: {
    flexDirection: 'row',
    width: '100%',
    backgroundColor: '#FFF',
    textAlign: 'center',
    padding: 2,
    color: "#66696F"
  },

  tableValueText : {
    fontSize: 10
  },

  ombudsman: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },

  ombudsmanText: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 16,
    color: '#313234'
  },
  ombudsmanSubText: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 12,
    maxWidth: '65%',
    color: theme.colors.text.medium,
    marginBottom: '15px'
  },
  commentGroupRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 2,
    width: '100%',
    backgroundColor: '#FFF',
    color: '#66696F'
  },
  commentGroupInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '80%'
  },

  commentGroupInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '72%',
  },
  commentGroupText: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 9,
    color: '#66696F'
  },
  commentGroupAmount: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '20%'
  },
  commentGroupAmountText: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 9,
    color: '#313234'
  }
});

export default ExtractPDF;